import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import clientApiController from "../../services/client.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import {
  clientListErrorFromAction,
  mergeClientListPage,
  normalizeClientViewResponse,
} from "../clientViewResponse";
import { normalizeClientSearchQuery } from "../../services/clientSearch";

export const ClientStoreApi = createAsyncThunk("client/create", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .create(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "create"))
      .catch((error) => HandleError(thunkAPI, error, "create"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const ClientUpdateApi = createAsyncThunk("client/update", async (formvalues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .update(formvalues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "update"))
      .catch((error) => HandleError(thunkAPI, error, "update"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue({ status: error.response.status, message: message });
  }
});

export const ClientListViewApi = createAsyncThunk("client/listview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "listview"))
      .catch((error) => HandleError(thunkAPI, error, "listview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientGridViewApi = createAsyncThunk("client/gridview", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "gridview"))
      .catch((error) => HandleError(thunkAPI, error, "gridview"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientDetailApi = createAsyncThunk("client/detail", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .view(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "detail"))
      .catch((error) => HandleError(thunkAPI, error, "detail"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientDeleteApi = createAsyncThunk("client/delete", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .deleted(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "delete"))
      .catch((error) => HandleError(thunkAPI, error, "delete"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientMergeListApi = createAsyncThunk("client/mergeList", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .mergeList(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "mergeList"))
      .catch((error) => HandleError(thunkAPI, error, "mergeList"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientMergeApi = createAsyncThunk("client/merge", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .mergeClients(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "merge"))
      .catch((error) => HandleError(thunkAPI, error, "merge"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientSuggetionListApi = createAsyncThunk("client/suggetionlist", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .suggetionlist(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "suggetionlist"))
      .catch((error) => HandleError(thunkAPI, error, "suggetionlist"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientImportApi = createAsyncThunk("client/Clientimport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .clientimport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Clientimport"))
      .catch((error) => HandleError(thunkAPI, error, "Clientimport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientExportApi = createAsyncThunk("client/Clientexport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .clientexport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Clientexport"))
      .catch((error) => HandleError(thunkAPI, error, "Clientexport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientSyncWithMailChimpsApi = createAsyncThunk("client/ClientSyncMailchimp", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .clientmailchimpsync(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "ClientSyncMailchimp"))
      .catch((error) => HandleError(thunkAPI, error, "ClientSyncMailchimp"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientVoucherImportApi = createAsyncThunk("voucher/Voucherimport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .clientvoucherimport(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Voucherimport"))
      .catch((error) => HandleError(thunkAPI, error, "Voucherimport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientSampleVoucherApi = createAsyncThunk("voucher/Vouchersample", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .clientvouchersample(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "Vouchersample"))
      .catch((error) => HandleError(thunkAPI, error, "Vouchersample"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const ClientVoucherExportApi = createAsyncThunk("voucher/voucherexport", async (formValues, thunkAPI) => {
  try {
    const resposedata = await clientApiController
      .clientvoucherexports(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "voucherexport"))
      .catch((error) => HandleError(thunkAPI, error, "voucherexport"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});


const initialState = {
  isTabView: "grid",
  isFromOpenAddClientForm: "",
  isOpenedAddForm: "",
  isOpenedDetailModal: "",
  isGridView: [],
  isListView: [],
  isSuggetionListView: [],
  isDetailData: "",
  detailClientId: null,
  detailRequestId: null,
  latestSuggestionRequestId: null,
  suggestionQueryKey: null,
  isClientDetailTab: "",
  isSort: "",
  isSearchList: "",
  isSearchName: "",
  isSearchObj: "",
  isClientDataToSale: "",
  isSetClientAppointmentCalendar: "",
  isCalendarClientBookingNext: false,
  calendarBookingNextSource: null,
  isOpenClientInvoiceImportModal: "",
  isOpenClientVoucherImportModal: "",
  clientListError: null,
  isApiStatus: {
    ClientStoreApi: "",
    ClientUpdateApi: "",
    ClientGridViewApi: "",
    ClientListViewApi: "",
    ClientSuggetionListApi: "",
    ClientDetailApi: "",
    ClientDeleteApi: "",
    ClientMergeListApi: "",
    ClientMergeApi: "",
    ClientImportApi: "",
    ClientExportApi: "",
    ClientSyncWithMailChimpsApi: "",
    ClientVoucherImportApi: "",
    ClientSampleVoucherApi: "",
    ClientVoucherExportApi: ""
  },
};

const isRenderableClient = (client) => (
  client
  && typeof client === "object"
  && client.id !== undefined
  && typeof client.first_name === "string"
  && typeof client.last_name === "string"
);

// The profile fetch opens the client drawer, so a late response for a
// previously selected client must never replace or blank the current one.
const detailClientIdFromAction = (action) => Number(action.meta.arg?.id) || null;
const ownsDetailRequest = (state, action) =>
  state.detailRequestId === action.meta.requestId
  && state.detailClientId === detailClientIdFromAction(action);

// Suggestion searches are dispatched per keystroke from the header and the
// clients page, so a late response for an abandoned prefix must not replace
// the rows for the current term. Pagination keeps the same query key so a
// continuation still appends to the current rows.
const suggestionQueryKeyFromAction = (action) =>
  normalizeClientSearchQuery(action.meta?.arg?.q);
const ownsSuggestionRequest = (state, action) =>
  state.latestSuggestionRequestId === action.meta?.requestId
  && state.suggestionQueryKey === suggestionQueryKeyFromAction(action);

export const clientSlice = createSlice({
  name: "client",
  initialState,
  reducers: {
    reset: () => initialState,
    ClientTabListView: (state) => {
      state.isOpenedAddForm = "";
      state.isOpenedDetailModal = "";
      state.isTabView = "list";
    },
    ClientTabGridView: (state) => {
      state.isOpenedAddForm = "";
      state.isOpenedDetailModal = "";
      state.isTabView = "grid";
    },
    FromOpenAddClientForm: (state, action) => {
      state.isOpenedDetailModal = "";
      state.isFromOpenAddClientForm = action.payload;
    },
    ResetFromOpenAddClientForm: (state) => {
      state.isOpenedDetailModal = "";
      state.isFromOpenAddClientForm = "";
    },
    OpenAddClientForm: (state, action) => {
      state.isOpenedDetailModal = "";
      state.isOpenedAddForm = action.payload;
    },
    CloseAddClientForm: (state, action) => {
      state.isOpenedDetailModal = "";
      state.isOpenedAddForm = action.payload;
    },
    OpenClientDetailModal: (state, action) => {
      state.isOpenedAddForm = "";
      state.isOpenedDetailModal = action.payload;
    },
    CloseClientDetailModal: (state, action) => {
      state.isOpenedAddForm = "";
      state.isOpenedDetailModal = action.payload;
      // Closing the drawer invalidates the in-flight detail request so a
      // delayed open cannot resurrect a stale drawer.
      state.detailRequestId = null;
    },
    ClientDetailTab: (state, action) => {
      state.isClientDetailTab = action.payload;
    },
    ClientSort: (state, action) => {
      let sort = state.isSort ? state.isSort : {};
      state.isSort = Object.assign(sort, action.payload);
    },
    ClientSortRemove: (state) => {
      state.isSort = "";
    },
    OpenClientSearchList: (state) => {
      state.isSearchList = "open";
    },
    CloseClientSearchList: (state) => {
      state.isSearchList = "";
    },
    ClientSearchName: (state, action) => {
      state.isSearchName = action.payload;
    },
    clearClientSearchResults: (state) => {
      state.isGridView = { data: [] };
      state.isListView = { data: [] };
      state.isSuggetionListView = { data: [] };
      state.clientListError = null;
      // Invalidate any in-flight suggestion response so a delayed result for
      // the cleared term cannot repopulate the dropdown.
      state.latestSuggestionRequestId = null;
      state.suggestionQueryKey = null;
      state.isApiStatus = {
        ...state.isApiStatus,
        ClientGridViewApi: "loading",
        ClientListViewApi: "loading",
        ClientSuggetionListApi: "loading",
      };
    },
    ClientSearchObj: (state, action) => {
      state.isSearchObj = action.payload;
    },
    ClientDataToSale: (state, action) => {
      state.isClientDataToSale = action.payload;
    },
    SetClientAppointmentCalendar: {
      prepare: (client, { bookingNext = false, sourceAppointment = null } = {}) => ({
        payload: client,
        meta: { bookingNext: bookingNext === true, sourceAppointment },
      }),
      reducer: (state, action) => {
        state.isSetClientAppointmentCalendar = action.payload;
        state.isCalendarClientBookingNext = Boolean(action.payload && action.meta?.bookingNext);
        state.calendarBookingNextSource = state.isCalendarClientBookingNext ? action.meta?.sourceAppointment || null : null;
      },
    },
    OpenClientInvoiceImportModal: (state, action) => {
      state.isOpenClientInvoiceImportModal = action.payload;
    },
    OpenClientVoucherImportModal: (state, action) => {
      state.isOpenClientVoucherImportModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    const clearSaleClient = (state) => {
      state.isSearchObj = '';
      state.isSearchName = '';
      state.isSearchList = '';
      state.isSuggetionListView = [];
      state.isClientDataToSale = '';
      state.isFromOpenAddClientForm = '';
      // A sale transition also abandons any in-flight suggestion lookup.
      state.latestSuggestionRequestId = null;
      state.suggestionQueryKey = null;
    };
    builder
      .addCase('sale/StartNewInvoice', clearSaleClient)
      .addCase('sale/OpenSaleCompleted', clearSaleClient)
      .addCase(ClientStoreApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientStoreApi: "loading" };
      })
      .addCase(ClientStoreApi.fulfilled, (state, action) => {
        // The API-compatible create response can contain only {id, message}.
        // Do not render that incomplete object before the form refreshes the
        // complete persisted client profile.
        if (isRenderableClient(action.payload)) {
          if (state.isGridView && state.isGridView.data) {
            state.isGridView.data = [action.payload, ...state.isGridView.data];
          } else {
            state.isGridView = { data: [action.payload] };
          }
          if (state.isListView && state.isListView.data) {
            state.isListView.data = [action.payload, ...state.isListView.data];
          } else {
            state.isListView = { data: [action.payload] };
          }
        }
        state.isApiStatus = { ...state.isApiStatus, ClientStoreApi: "succeeded" };
      })
      .addCase(ClientStoreApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientStoreApi: "failed" };
      })
      .addCase(ClientUpdateApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientUpdateApi: "loading" };
      })
      .addCase(ClientUpdateApi.fulfilled, (state, action) => {
        const { id, ...changes } = action.payload;
        let isGridView = state.isGridView && state.isGridView.data ? state.isGridView.data : state.isGridView;
        let isListView = state.isListView && state.isListView.data ? state.isListView.data : state.isListView;
        const existingGridData = isGridView ? isGridView.find((event) => event.id === id) : "";
        const existingListData = isListView ? isListView.find((event) => event.id === id) : "";
        if (existingGridData) {
          Object.keys(changes).map((keyName) => {
            existingGridData[keyName] = changes[keyName];
          });
        }
        if (existingListData) {
          Object.keys(changes).map((keyName) => {
            existingListData[keyName] = changes[keyName];
          });
        }
        state.isApiStatus = { ...state.isApiStatus, ClientUpdateApi: "succeeded" };
      })
      .addCase(ClientUpdateApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientUpdateApi: "failed" };
      })
      .addCase(ClientGridViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientGridViewApi: "loading" };
        state.clientListError = null;
      })
      .addCase(ClientGridViewApi.fulfilled, (state, action) => {
        state.isGridView = mergeClientListPage(state.isGridView, normalizeClientViewResponse(action.payload));
        state.isApiStatus = { ...state.isApiStatus, ClientGridViewApi: "succeeded" };
      })
      .addCase(ClientGridViewApi.rejected, (state, action) => {
        state.clientListError = clientListErrorFromAction(action);
        state.isApiStatus = { ...state.isApiStatus, ClientGridViewApi: "failed" };
      })
      .addCase(ClientListViewApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientListViewApi: "loading" };
        state.clientListError = null;
      })
      .addCase(ClientListViewApi.fulfilled, (state, action) => {
        state.isListView = mergeClientListPage(state.isListView, normalizeClientViewResponse(action.payload));
        state.isApiStatus = { ...state.isApiStatus, ClientListViewApi: "succeeded" };
      })
      .addCase(ClientListViewApi.rejected, (state, action) => {
        state.clientListError = clientListErrorFromAction(action);
        state.isApiStatus = { ...state.isApiStatus, ClientListViewApi: "failed" };
      })

      .addCase(ClientSuggetionListApi.pending, (state, action) => {
        const queryKey = suggestionQueryKeyFromAction(action);
        if (state.suggestionQueryKey !== queryKey) {
          state.isSuggetionListView = { data: [] };
        }
        state.suggestionQueryKey = queryKey;
        state.latestSuggestionRequestId = action.meta.requestId;
        state.isApiStatus = { ...state.isApiStatus, ClientSuggetionListApi: "loading" };
        state.clientListError = null;
      })
      .addCase(ClientSuggetionListApi.fulfilled, (state, action) => {
        if (!ownsSuggestionRequest(state, action)) return;
        state.isSuggetionListView = mergeClientListPage(state.isSuggetionListView, normalizeClientViewResponse(action.payload));
        state.isApiStatus = { ...state.isApiStatus, ClientSuggetionListApi: "succeeded" };
      })
      .addCase(ClientSuggetionListApi.rejected, (state, action) => {
        if (!ownsSuggestionRequest(state, action)) return;
        state.clientListError = clientListErrorFromAction(action);
        state.isApiStatus = { ...state.isApiStatus, ClientSuggetionListApi: "failed" };
      })
      .addCase(ClientDetailApi.pending, (state, action) => {
        const clientId = detailClientIdFromAction(action);
        if (state.detailClientId !== clientId) state.isDetailData = "";
        state.detailClientId = clientId;
        state.detailRequestId = action.meta.requestId;
        state.isApiStatus = { ...state.isApiStatus, ClientDetailApi: "loading" };
      })
      .addCase(ClientDetailApi.fulfilled, (state, action) => {
        if (!ownsDetailRequest(state, action)) return;
        state.isDetailData = action.payload;
        state.isApiStatus = { ...state.isApiStatus, ClientDetailApi: "succeeded" };
      })
      .addCase(ClientDetailApi.rejected, (state, action) => {
        if (!ownsDetailRequest(state, action)) return;
        state.isDetailData = "";
        state.isApiStatus = { ...state.isApiStatus, ClientDetailApi: "failed" };
      })
      .addCase(ClientDeleteApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientDeleteApi: "loading" };
      })
      .addCase(ClientDeleteApi.fulfilled, (state, action) => {
        const { id } = action.payload;
        state.isGridView.data = state.isGridView.data ? state.isGridView.data.filter((item) => item.id != id) : state.isGridView.filter((item) => item.id != id);
        state.isListView.data = state.isListView.data ? state.isListView.data.filter((item) => item.id != id) : state.isListView.filter((item) => item.id != id);
        state.isApiStatus = { ...state.isApiStatus, ClientDeleteApi: "succeeded" };
      })
      .addCase(ClientDeleteApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientDeleteApi: "failed" };
      })
      .addCase(ClientMergeApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientMergeApi: "loading" };
      })
      .addCase(ClientMergeApi.fulfilled, (state, action) => {
        const rawIds = (action.meta.arg && action.meta.arg.merge_client_ids) || [];
        const idSet = new Set(rawIds.map((x) => Number(x)));
        if (state.isGridView && state.isGridView.data) {
          state.isGridView.data = state.isGridView.data.filter((item) => !idSet.has(Number(item.id)));
        } else if (state.isGridView && Array.isArray(state.isGridView)) {
          state.isGridView = state.isGridView.filter((item) => !idSet.has(Number(item.id)));
        }
        if (state.isListView && state.isListView.data) {
          state.isListView.data = state.isListView.data.filter((item) => !idSet.has(Number(item.id)));
        } else if (state.isListView && Array.isArray(state.isListView)) {
          state.isListView = state.isListView.filter((item) => !idSet.has(Number(item.id)));
        }
        state.isApiStatus = { ...state.isApiStatus, ClientMergeApi: "succeeded" };
      })
      .addCase(ClientMergeApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientMergeApi: "failed" };
      })
      .addCase(ClientImportApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientImportApi: "loading" };
      })
      .addCase(ClientImportApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientImportApi: "succeeded" };
      })
      .addCase(ClientImportApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientImportApi: "failed" };
      })
      .addCase(ClientExportApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientExportApi: "loading" };
      })
      .addCase(ClientExportApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientExportApi: "succeeded" };
      })
      .addCase(ClientExportApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientExportApi: "failed" };
      })
      .addCase(ClientSyncWithMailChimpsApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSyncWithMailChimpsApi: "loading" };
      })
      .addCase(ClientSyncWithMailChimpsApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSyncWithMailChimpsApi: "succeeded" };
      })
      .addCase(ClientSyncWithMailChimpsApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSyncWithMailChimpsApi: "failed" };
      })
      .addCase(ClientVoucherImportApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherImportApi: "loading" };
      })
      .addCase(ClientVoucherImportApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherImportApi: "succeeded" };
      })
      .addCase(ClientVoucherImportApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherImportApi: "failed" };
      })
      .addCase(ClientSampleVoucherApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSampleVoucherApi: "loading" };
      })
      .addCase(ClientSampleVoucherApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSampleVoucherApi: "succeeded" };
      })
      .addCase(ClientSampleVoucherApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientSampleVoucherApi: "failed" };
      })
      .addCase(ClientVoucherExportApi.pending, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherExportApi: "loading" };
      })
      .addCase(ClientVoucherExportApi.fulfilled, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherExportApi: "succeeded" };
      })
      .addCase(ClientVoucherExportApi.rejected, (state) => {
        state.isApiStatus = { ...state.isApiStatus, ClientVoucherExportApi: "failed" };
      });
  },
});
// Action creators are generated for each case reducer function
export const { reset, ClientTabListView, ClientTabGridView, FromOpenAddClientForm, OpenAddClientForm, CloseAddClientForm, OpenClientDetailModal, CloseClientDetailModal, ClientDetailTab, ClientSort, ClientSortRemove, OpenClientSearchList, CloseClientSearchList, ClientSearchName, clearClientSearchResults, ClientSearchObj, ClientDataToSale, SetClientAppointmentCalendar, OpenClientInvoiceImportModal, ResetFromOpenAddClientForm, OpenClientVoucherImportModal } = clientSlice.actions;
export default clientSlice.reducer;
